import React, { FC } from "react";
import Heading from "components/Heading/Heading";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

const FOUNDER_DEMO: Statistic[] = [
  {
    id: "1",
    heading: "No waiting in line ",
    subHeading: "",
  },
  {
    id: "2",
    heading: "No painful paperwork ",
    subHeading: "",
  },
  {
    id: "3",
    heading: "Clear, straightforward pricing ",
    subHeading: "",
  },
];

export interface SectionStatisticProps {
  className?: string;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading
      // desc=" We’re impartial and independent, and every day we create distinctive,
      //   world-class programmes and content"
      >
        Why us?
      </Heading>
      <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8">
        {FOUNDER_DEMO.map((item) => (
          <div
            key={item.id}
            className="p-6 bg-neutral-50 dark:bg-neutral-800 rounded-md dark:border-neutral-800 items-center flex"
          >
            <h3 className="text-2xl font-semibold leading-none text-white md:text-3xl dark:text-neutral-200">
              {item.heading}
            </h3>
            {/* <span className="block text-sm text-neutral-500 mt-3 sm:text-base dark:text-neutral-400">
              {item.subHeading}
            </span> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionStatistic;
